module.exports = __webpack_public_path__ + "static/media/s4.609be273.svg";